module.exports = __webpack_public_path__ + "static/assets/5330b28be4bd8232e25d4f1755076035.gif";